module.exports = __webpack_public_path__ + "static/media/category10.a29dc26e.png";